import { CSSProperties, useEffect, useState } from 'react';

import Radio from '../radio/radio';
import styles from './index.module.scss';

interface radioData {
  id: string;
  isChecked: boolean;
  value: string;
  disabled: boolean;
}

interface radioGroupProps {
  label?: string;
  data: radioData[];
  name: string;
  onChange: (value: radioData[]) => {};
  style: CSSProperties;
}

const RadioGroup = ({
  label,
  data,
  name,
  onChange,
  style,
}: radioGroupProps) => {
  const [radioData, setRadioData] = useState(data);

  useEffect(() => {
    setRadioData(data);
  }, [data]);

  const onChangeHandler = (e: string): void => {
    const newData = radioData.map((d) => {
      if (d.id === e) {
        return { ...d, isChecked: true };
      } else {
        return { ...d, isChecked: false };
      }
    });
    setRadioData(newData);
    onChange(newData);
  };

  return (
    <>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles['radio-group']}>
        {radioData.map((d) => {
          return (
            <Radio
              key={d.id}
              isChecked={d.isChecked}
              id={d.id}
              value={d.value}
              name={name}
              onChange={onChangeHandler}
              style={style}
              disabled={d.disabled}
            />
          );
        })}
      </div>
    </>
  );
};

export default RadioGroup;
